var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",null,{"attrs":{
      errorMessages: _vm.getServerErrors || _vm.activeErrorMessages,
      label: this.$t(("fields." + _vm.name))
    },"hasErrors":_vm.hasErrors,"listeners":{ blur: function () { return _vm.preferredValidator.$touch(); } }})],2)}
var staticRenderFns = []

export { render, staticRenderFns }